import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useGetOrderByIdQuery } from "../slices/OrdersSlice";
import OrderConfirmationScreen from "./OrderConfirmationScreen";
import { useSelector } from "react-redux";

const OrderDetailsScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const { orderId } = useParams();
  const shouldFetch = !orderId;
  const {
    data: orderDetails,
    error,
    isLoading,
    refetch,
  } = useGetOrderByIdQuery(
    { orderId, token: userInfo.token },
    { skip: shouldFetch }
  );

  return (
    <>{orderDetails && <OrderConfirmationScreen propOrder={orderDetails} />}</>
  );
};

export default OrderDetailsScreen;
